import React, { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';

import { ChinaGeoCoordMap } from '../../Libs/echarts';
import * as SThunk from '../../slices/statistics/thunk';

const fontSize = 15;
const labelPadding = [fontSize * 0.5, fontSize * 0.5, fontSize * 0.375, fontSize * 0.5];
const customRegions = [];
for (const key of Object.keys(ChinaGeoCoordMap)) {
    customRegions.push({ name: key, emphasis: { label: { position: [...ChinaGeoCoordMap[key].position] } } });
}

const BaseGeoChartOption = {
    backgroundColor: 'transparent',
    geo: {
        map: 'china',
        show: true,
        aspectScale: 0.875,
        zoom: 1.5,
        layoutCenter: ['50%', '50%'],
        layoutSize: '100%',
        itemStyle: {
            areaColor: '#0c274b',
            borderColor: '#1cccff',
            borderWidth: 1.5
        },
        emphasis: {
            itemStyle: {
                areaColor: '#02102b'
            },
            label: {
                show: true,
                color: '#fff',
                fontSize: fontSize * 0.875,
                offset: [0, fontSize]
            }
        },
        regions: customRegions
    },
    series: [
        {
            type: 'scatter',
            coordinateSystem: 'geo',
            zlevel: 1,
            symbol: 'path://M896 192l-384 640-384-640z',
            symbolSize: 0.875 * fontSize,
            opacity: 1,
            itemStyle: {
                color: '#fff'
            },
            label: {
                show: true,
                align: 'left',
                opacity: 1,
                offset: [-fontSize, -fontSize * 1.125],
                backgroundColor: 'transparent',
                formatter(params) {
                    const v = (params.value || [])[2];

                    return !!v ? `{name|${params.name}}{value|${v}}` : '';
                },
                rich: {
                    cname: {
                        fontSize: fontSize,
                        color: '#fff',
                        fontWeight: 500
                    },
                    name: {
                        fontSize: fontSize,
                        color: '#4d555e',
                        backgroundColor: '#fff',
                        fontWeight: 500,
                        padding: labelPadding,
                        align: 'left',
                        verticalAlign: 'middle',
                        borderRadius: [5, 0, 0, 5],
                        distance: 0
                    },
                    value: {
                        fontSize: fontSize,
                        color: '#fff',
                        backgroundColor: '#f44336',
                        fontWeight: 500,
                        padding: labelPadding,
                        borderRadius: [0, 5, 5, 0],
                        align: 'right',
                        verticalAlign: 'middle',
                        distance: 0
                    }
                }
            },
            data: []
        }
    ]
};

const VehicleDistributionMap = ({ style }) => {
    const chartData = useSelector(state => state.Statistics.dashboard.vehicleDistributionMapData);
    const [geoChartOption, setGeoChartOption] = useState({});

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(SThunk.dashboard());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const options = _.cloneDeep(BaseGeoChartOption);
        options.series[0].data = chartData || [];
        setGeoChartOption(options);
    }, [chartData]);

    // const EventsDict = {};
    function onChartReadyCallback() {
        console.log('onChartReadyCallback', arguments);
    }

    return <ReactECharts style={style} option={geoChartOption} notMerge={true} lazyUpdate={true} theme={'dark'} onChartReady={onChartReadyCallback} />;
};

export default VehicleDistributionMap;
